(function() {
  // Add custom code below this line

  // Switch collection grid layout
  window.addEventListener('load', function() {
    const changeViewWrapper = document.querySelector('.change-view-wrapper');

    if (changeViewWrapper) {
      // Switch collection grid layout
      const fourColumnBtn = document.getElementById('four-columns-grid');
      const sixColumnBtn = document.getElementById('six-columns-grid');

      // Get the grid element
      const gridElement = document.getElementById('product-grid');

      // Retrieve the selected view from Local Storage, if available
      const savedView = localStorage.getItem('selectedView');
      if (savedView === 'four') {
        gridElement.classList.add('grid--4-col-desktop');
        gridElement.classList.remove('grid--6-col-desktop');
        fourColumnBtn.classList.add('selected');
      } else if (savedView === 'six') {
        gridElement.classList.remove('grid--4-col-desktop');
        gridElement.classList.add('grid--6-col-desktop');
        sixColumnBtn.classList.add('selected');
      }

      // Add event listeners to the buttons
      fourColumnBtn.addEventListener('click', () => toggleColumns('four'));
      sixColumnBtn.addEventListener('click', () => toggleColumns('six'));

      function toggleColumns(columns) {
        // Remove "selected" class from both buttons initially
        fourColumnBtn.classList.remove('selected');
        sixColumnBtn.classList.remove('selected');

        if (columns === 'six') {
          gridElement.classList.remove('grid--4-col-desktop');
          gridElement.classList.add('grid--6-col-desktop');
          sixColumnBtn.classList.add('selected');
        } else if (columns === 'four') {
          gridElement.classList.remove('grid--6-col-desktop');
          gridElement.classList.add('grid--4-col-desktop');
          fourColumnBtn.classList.add('selected');
        }

        // Save the selected view to Local Storage
        localStorage.setItem('selectedView', columns);
      }
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
